import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';

interface MyOrderLoadErrorProps {
  readonly onRetry: () => void;
}

/** 상세를 처음부터 읽지 못했을 때 — 내 견적 상세의 오류 칸과 같은 모양(얇은 위아래 선, 가운데 안내와 다시 시도). */
export const MyOrderLoadError = ({ onRetry }: MyOrderLoadErrorProps): ReactElement => (
  <div
    role="alert"
    className="flex flex-col items-center gap-4 border-y border-foreground/10 py-12 text-center"
  >
    <p className="text-sm text-destructive">주문을 불러오지 못했습니다.</p>
    <Button variant="outline" size="sm" onClick={onRetry}>
      다시 시도
    </Button>
  </div>
);
